const env = import.meta.env;

const buildNumber = env.VITE_CODEBUILD_BUILD_NUMBER;
const sentryEnv = env.VITE_SENTRY_ENV;
const tenantId = env.VITE_TENANT_ID;
const wafCaptcha = env.VITE_WAF_API_URL;
const wafApiKey = env.VITE_WAF_API_KEY;

export const Config = {
  /** Tenant ID for API requests. */
  tenantId,
  /** Base URL for API. */
  baseURL: env.VITE_BASE_URL,
  /** Login by guest ID */
  isLoginByGuestId: env.VITE_LOGIN_BY_GUEST_ID === 'true',
  /** AWS WAF */
  waf: {
    apiKey: wafApiKey,
    apiUrl: wafCaptcha,
    enabled: !!wafCaptcha && !!wafApiKey,
  },
  /** Languages for translation */
  supportedLanguages:
    env.VITE_SUPPORTED_LANGUAGES?.split(',')
      .map((lang) => lang.trim())
      .filter(Boolean) ?? [],
  /** Sentry  configuratiin **/
  sentry: {
    env: sentryEnv,
    dsn: env.VITE_SENTRY_DSN,
    release:
      sentryEnv && buildNumber
        ? `${sentryEnv}-${tenantId}-${buildNumber}`
        : undefined,
  },
};
